import React from "react"; 

function TodosError({error}) {
    return <p>Desespérate, hubo un error</p>
}

export default TodosError;
